import { useQuery } from "@tanstack/react-query";

import { WORKSPACE_KEY } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getWorkspacesMock } from "@/mock/handlers/workspace";
import { Response } from "@/types/pagination";
import { Workspace } from "@/types/workspace";

import { api } from "@/lib/api-client";

export const useGetAllWorkspaces = () => {
  return useQuery({
    queryKey: [...WORKSPACE_KEY, "ALL"],
    enabled: true,
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        return getWorkspacesMock();
      }

      const { data } = await api.get("workspaces").json<Response<Workspace[]>>();

      return data;
    },
  });
};
